'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'swords-laser';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e03d';
var svgPathData = ['M19.3-2.9l234.3 263.6 152.2 0-5.4-4.8-338.9-301.2C49.7-55.8 31.7-55.2 20.5-44S8.7-14.7 19.3-2.9zM344.5 142.3l71.6 62.2 194.3-218.6c10.6-11.9 10-29.9-1.2-41.1S580-67 568.1-56.4L344.5 142.3z', 'M385.9 433.5l112-112-51.3-51.3c-6-6-14.1-9.4-22.6-9.4l-172.1 0c-14.3 0-21.4 17.2-11.3 27.3L385.9 433.5zm220.7 41.9c12.5-12.5 12.5-32.8 0-45.3l-86.1-86.1-44.7 44.7 108.7 108.7 22.1-22.1zm-66.7 66.7l22.1-22.1-108.7-108.7-44.7 44.7 86.1 86.1c12.5 12.5 32.8 12.5 45.3 0zM267.3 382.7l-96-96-26.7 26.7 96 96 26.7-26.7zm-74.7 74.7l25.4-25.4-96-96-25.4 25.4 96 96zM11.9 446.2c-12.5 12.5-12.5 32.8 0 45.3l50.7 50.7c12.5 12.5 32.8 12.5 45.3 0l62.1-62.1-96-96-62.1 62.1z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSwordsLaser = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;